var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('power-bi',{attrs:{"code":"eyJrIjoiYWRiMWM5ZWEtNDNiZS00YTc2LTg1MmQtY2UxOGZhMzI0ZTJhIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"}})}
var staticRenderFns = []

export { render, staticRenderFns }